<app-standard-image
  [imageUrl]="resolvedImageUrl()"
  [fallbackImageUrl]="resolvedFallbackImageUrl()"
  [iconSize]="iconSize()"
></app-standard-image>
